import React from 'react';
import { Currency, DateTime } from '~/components';
import { BulkActionModal } from '~/components/bulk-action';
import { useApi, useWorkspace } from '~/contexts';

export default function BulkDelete({ projectId, ids, currency, onClose, onComplete }) {
  const { workspace } = useWorkspace();
  const api = useApi();

  const renderRow = ({ revenueRecognitionEntry }) => (
    <>
      <DateTime value={revenueRecognitionEntry.date} /> &middot;{' '}
      <Currency value={revenueRecognitionEntry.amount} currency={currency} />
    </>
  );

  return (
    <BulkActionModal
      title="Delete Revenue Recognition Entries"
      variant="delete"
      onClose={onClose}
      onComplete={onComplete}
      onConfirm={() =>
        api.www
          .workspaces(workspace.id)
          .projectSettings(projectId)
          .revenueRecognitionEntries()
          .bulkDelete(ids)
          .then((r) => r.data)
      }
      renderRow={renderRow}>
      {`This will delete the selected revenue recognition ${
        ids.length === 1 ? 'entry' : 'entries'
      }. This action cannot be undone.`}
    </BulkActionModal>
  );
}
